import { createSelector } from 'reselect';

import { ReduxState } from '../state';
import { WindowSizeState } from './state';

export const selectWindowSize = (state: ReduxState): WindowSizeState =>
  state.WindowSize;

export const selectWindowWidth = createSelector(
  selectWindowSize,
  (windowSize): number | null => windowSize.width || null
);
